import { IResellerConfig } from '~/config/shared/reseller-config';
import { changeFavicon } from '~/src/dash/resellers/utils/utils';

// Define RESELLER_CONFIG with the appropriate reseller config
const RESELLER_CONFIG = (window as any).CONFIG as IResellerConfig;

// Change favicon
changeFavicon(RESELLER_CONFIG.faviconURL);
// Change title
document.title = RESELLER_CONFIG.title === 'Orka' ? 'Orka Ads MAS' : RESELLER_CONFIG.title;

// -------- Getters

export const getColorTheme = (key: string): string => {
  if (key === '' || key === undefined) {
    return '#FF00FF';
  }
  return (RESELLER_CONFIG.theme as any)[key];
};

export const getPbsUS = (): string => {
  return RESELLER_CONFIG.pbsUSDomain;
};

export const getPbsEU = (): string => {
  return RESELLER_CONFIG.pbsEUDomain;
};

export const getPbsAPAC = (): string => {
  return RESELLER_CONFIG.pbsAPACDomain;
};

export const getContactEmail = (): string => {
  return RESELLER_CONFIG.contactEmail;
};

export const getDemoPublisherName = (): string => {
  return RESELLER_CONFIG.demoPublisherName;
};

export const getDemoSSAIUsername = (): string => {
  return RESELLER_CONFIG.demoSSAIUsername || '';
};

export const getDemoUsernames = (): string[] => {
  const demoAccounts = [RESELLER_CONFIG.demoUsername];

  if (RESELLER_CONFIG.demoSSAIUsername) {
    demoAccounts.push(RESELLER_CONFIG.demoSSAIUsername);
  }

  return demoAccounts;
};

export const getLogoURL = (): string => {
  return RESELLER_CONFIG.logoURL;
};

export const getRoundLogoURL = (): string => {
  return RESELLER_CONFIG.roundLogoURL;
};

export const getApiDomain = (): string => {
  // else (if prod)
  return RESELLER_CONFIG.apiDomain;
};

export const getStreamDomain = (): string => {
  return RESELLER_CONFIG.streamUSDomain;
};

export const getMacrosWiki = (): string => {
  return RESELLER_CONFIG.macrosWiki;
};

export const getTechnicalDocumentationWiki = (): string => {
  return RESELLER_CONFIG.technicalDocumentationWiki;
};

export const getBulkUploaderDocumentationWiki = (): string => {
  return RESELLER_CONFIG.bulkUploaderDocumentationWiki;
};

export const getSSAIWiki = (): string => {
  return RESELLER_CONFIG.ssaiWiki;
};

export const getAuthToken = (): string => {
  return RESELLER_CONFIG.token;
};

export const getStorage = (): string => {
  return RESELLER_CONFIG.storage;
};

export const getEnv = (): string => {
  return RESELLER_CONFIG.env;
};

export const getResellerID = (): number => {
  return RESELLER_CONFIG.resellerID;
};

export const getResellerTitle = (): string => {
  return RESELLER_CONFIG.title;
};

export const isDebug = (): boolean => {
  return localStorage.getItem(RESELLER_CONFIG.storage + '.debug') === '1';
};

export const isIntegralplatform = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'ias publisher';
};

export const isPublica = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'publica';
};

export const isRoku = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'roku';
};

export const isEvrideo = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'evrideo';
};

export const isOrka = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'orka';
};

export const isOttera = (): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'ottera';
};

export const isOtteraSubpublisher = (publisherID: string): boolean => {
  return RESELLER_CONFIG.title.toLowerCase() === 'ottera' && !['475', '925'].includes(publisherID);
};

export const isOtteraMainAccounts = (publisherID: string): boolean => {
  return ['475', '924', '925'].includes(publisherID);
};

interface IPRInfo {
  pr_title?: string;
  pr_url?: string;
  pr_owner?: string;
  pr_branch?: string;
}

export const getPrInfo = (): IPRInfo => {
  return {
    pr_title: RESELLER_CONFIG.pr_title,
    pr_url: RESELLER_CONFIG.pr_url,
    pr_owner: RESELLER_CONFIG.pr_owner,
    pr_branch: RESELLER_CONFIG.pr_branch,
  };
};

export const getPREnabled = (): boolean => {
  return RESELLER_CONFIG.pr_enabled === true;
};
